<template>
    <div class="sidebar-card">
        <h1 class="heading-border-bottom-anim">{{dlabData.questions.rightSidebar.trendingTags.title}}</h1>
        <ul class="sidebar-trending-tags d-flex flex-column">

            <li class="sidebar-trending-qst" v-for="(tag, i) in dlabData.questions.rightSidebar.trendingTags.tags" :key="i">
                <router-link class="d-flex align-center justify-content-between" to="/">
                    <span>{{tag.name}}</span> {{tag.number}}
                </router-link>
            </li>

        </ul>
    </div>
</template>

<script>
import dlabData from '@/store/store.js'

export default {
    name: 'TrendingTags',
    data() {
        return {
            dlabData
        }
    }
}
</script>